var _desc, _defs, _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobilerMenuIconOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 15.079999999999998,
    viewBox: "241 -65.99999999999997 23 15.079999999999998",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 4.6.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 252.5 -58.46)",
    id: "_6Z2Gje_IV2LDaHXFKhnt",
    clipPath: "url(#CLIPPATH_98)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "CLIPPATH_98"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1 0 0 1 -156.5 308.46) translate(-187.5, -333.5)",
    id: "clip-Q_A_-_Mobile_-_Messages_new_For_Review",
    d: "M 0 0 L 375 0 L 375 667 L 0 667 z",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-11, -16.04)",
    d: "M 0 9 L 0 9.88 L 22 9.88 L 22 9 z M 0 15.6 L 0 16.48 L 22 16.48 L 22 15.6 z M 0 22.2 L 0 23.08 L 22 23.08 L 22 22.2 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilerMenuIconOpen);
export default __webpack_public_path__ + "static/media/mobiler-menu-icon-open.d74a50ea11c4c370212cafef9463e860.svg";
export { ForwardRef as ReactComponent };